/**
 * Locale (en-US) — copy specific to the modern Tasks list. Only new
 * keys are added; we reuse existing translations from
 * `tasks/locales/en-US.js` for status, importance and type labels.
 */
export default {
  'tasksModern.title': 'Tasks',
  'tasksModern.summary':
    'Manage your pending work, plan your day and track your approvals at a glance.',
  'tasksModern.refresh': 'Refresh',
  'tasksModern.newTask': 'Add task',

  'tasksModern.row.moreActions': 'More actions',
  'tasksModern.row.hasNotes': 'This task has a note',
  'tasksModern.row.created': 'Created',
  'tasksModern.row.planned': 'Planned',
  'tasksModern.row.overdue': 'Due',
  'tasksModern.row.reminder': 'Reminder',
  'tasksModern.row.relatedPeople':
    '{count, plural, one {# related person} other {# related people}}',

  'tasksModern.date.today': 'Today',
  'tasksModern.date.tomorrow': 'Tomorrow',
  'tasksModern.date.yesterday': 'Yesterday',

  'tasksModern.filters.toggle': 'Filters',
  'tasksModern.filters.clearAll': 'Clear all',

  'tasksModern.toolbar.order.desc': 'Newest',
  'tasksModern.toolbar.order.asc': 'Oldest',

  'tasksModern.empty.noTasks.title': 'No tasks here yet',
  'tasksModern.empty.noTasks.titleFor': 'No tasks in "{name}" yet',
  'tasksModern.empty.noTasks.description':
    'When new tasks are assigned or added to this list, they will show up here.',

  'tasksModern.empty.noResults.title': 'No tasks found',
  'tasksModern.empty.noResults.titleFor': 'No matches under "{name}"',
  'tasksModern.empty.noResults.description':
    'Adjust your filters or date range to see more results.',

  // ────────── "New task" drawer (MS To Do style) ──────────
  'tasksModern.newTask.heroTitle': 'New task',
  'tasksModern.newTask.heroSummary': 'Capture it before it slips away.',
  'tasksModern.newTask.titlePlaceholder': 'What do you need to do?',
  'tasksModern.newTask.notesPlaceholder': 'Add a note, link or checklist…',
  'tasksModern.newTask.dateHint': 'Pick a date',
  'tasksModern.newTask.cta': 'Create task',
  'tasksModern.newTask.quickLabel': 'Plan',
  'tasksModern.newTask.today': 'Today',
  'tasksModern.newTask.tomorrow': 'Tomorrow',
  'tasksModern.newTask.nextWeek': 'In 7 days',

  // ────────── Detail drawer (autosave) ──────────
  'tasksModern.detail.heroTitle': 'Task details',
  'tasksModern.detail.editTitle': 'Click to edit the title',
  'tasksModern.detail.changeStatus': 'Change status',
  'tasksModern.detail.requestedBy': 'Requested by',
  'tasksModern.detail.createdAt': 'Created',
  'tasksModern.detail.relatedUsers': 'Related people',
  'tasksModern.detail.actions': 'Actions',
  'tasksModern.detail.savedHint': 'Changes are saved automatically',
  'tasksModern.detail.notesPlaceholder': 'Add context, links or a checklist…',

  // ────────── MS To Do-style date picker ──────────
  'tasksModern.smartDate.placeholder': 'Pick a date',
  'tasksModern.smartDate.today': 'Today',
  'tasksModern.smartDate.tomorrow': 'Tomorrow',
  'tasksModern.smartDate.nextWeek': 'Next week',
  'tasksModern.smartDate.pick': 'Pick a date',
  'tasksModern.smartDate.clear': 'Clear',

  // ────────── Date validation ──────────
  'tasksModern.dateValidation.future':
    'The "{field}" date must be later than the current date and time.',
};
